import React, { useMemo } from "react";
import styels from './sideMenu.module.scss'
import classNames from "classnames";
import tw from "@/styles/tailwind";
import { useUserInfo } from "@/api/request";
import Icon from "@/wmCompoments/Icon";
import { IconName } from "@/wmCompoments/Icon/iconTypes";
import { useLocation, useNavigate } from "react-router";
import { useModal } from "@/modals/modalContext";
import { useAuth } from "@/provides/authProvider";
import Toast from "@/wmCompoments/toast";
import { useTranslation } from "react-i18next";

const SideMenu = () => {
    const { t } = useTranslation('mine')
    const { data } = useUserInfo()

    const { pathname } = useLocation()
    const navigate = useNavigate()
    const { openModal } = useModal()

    const { logout } = useAuth()

    const menus = useMemo(() => {
        return [
            {
                icon: 'icon-mine-wallet',
                text: t('centralWallet'),
                iconClass: 'w-[19px]',
                activity: pathname === '/mine/centralWallet',
                onClick: ()=>{
                    navigate('/mine/centralWallet')
                }
            },
            {
                icon: 'icon-mine-user',
                text: t('profile'),
                iconClass: 'w-[19px]',
                activity: pathname === '/mine/personalInfo',
                onClick: ()=>{
                    navigate('/mine/personalInfo')
                }
            },
            {
                icon: 'icon-mine-account',
                text: t('accountManagement'),
                iconClass: 'w-[19px]',
                activity: pathname.includes('/mine/accountManagement'),
                onClick: ()=>{
                    navigate('/mine/accountManagement')
                }
            },
            {
                type: 'line'
            },
            {
                icon: 'icon-mine-invite',
                text: t('inviteFriends'),
                iconClass: 'w-[19px]',
                activity: pathname === '/mine/inviteFriends',
                onClick: ()=>{
                    navigate('/mine/inviteFriends')
                }
            },
            {
                icon: 'icon-mine-bet',
                text: t("betOrderRecords"),
                iconClass: 'w-[19px]',
                activity: pathname === '/mine/betOrderRecords',
                onClick: ()=>{
                    navigate('/mine/betOrderRecords')
                }
            },
            {
                icon: 'icon-mine-transfer',
                text: t('transferCenter'),
                iconClass: 'w-[19px]',
                activity: pathname === '/mine/transferCenter',
                onClick: ()=>{
                    navigate('/mine/transferCenter')
                }
            },
            {
                icon: 'icon-mine-feedback',
                text: t('feedback'),
                iconClass: 'w-[19px]',
                activity: pathname === '/mine/feedback' || pathname === '/mine/myFeedback',
                onClick: ()=>{
                    navigate('/mine/feedback')
                }
            },
            {
                type: 'line'
            },
            {
                icon: 'icon-mine-award',
                text: t('awardRecord'),
                iconClass: 'w-[19px] h-[20px]',
                activity: pathname === '/mine/awardRecord',
                onClick: ()=>{
                    navigate('/mine/awardRecord')
                }
            },
            {
                icon: 'icon-mine-transaction',
                text: t('transactionRecord'),
                iconClass: 'w-[19px] h-[20px]',
                activity: pathname === '/mine/transactionRecords',
                onClick: ()=>{
                    navigate('/mine/transactionRecords')
                }
            },
            {
                icon: 'icon-mine-message',
                text: t('messageCenter'),
                iconClass: 'w-[19px] h-[20px]',
                activity: pathname === '/mine/messageCenter',
                onClick: ()=>{
                    navigate('/mine/messageCenter')
                }
            },
            // {
            //     icon: 'icon-mine-join',
            //     text: '代理合作',
            //     iconClass: 'w-[15px] h-[21px]'
            // },
            {
                icon: 'icon-mine-exchange',
                text: t('walletExchange'),
                iconClass: 'w-[19px]',
                activity: pathname === '/mine/walletExchange',
                onClick: ()=>{
                    navigate('/mine/walletExchange')
                }
            },
            {
                icon: 'icon-mine-amount',
                text: t('logout'),
                iconClass: 'w-[19px]',
                onClick: ()=>{
                    logout()
                }
            }
        ]
    }, [pathname])

    
    return <div className={classNames(styels.sideMenu)}>
        <div className={classNames(tw.columns_center, 'w-full')}>

            <div className={classNames(tw.columns_center,'w-full')}>
                <div className="w-[80px] h-[80px] rounded-[50%] overflow-hidden" onClick={()=>{
                    openModal('avatar') // 打开头像选择器
                }}>
                    <img src={data?.avatar} />
                </div>

                <span className="mt-[12px] text-[#fff] text-[16px]">{data?.name}</span>


                <div className={classNames(tw.row_center, 'mt-[10px]', 'cursor-pointer')} onClick={() => {
                    if (ut.copyBoard(data?.id)) {
                        Toast.show(t('copySuccess'))
                    }
                }}>
                    <span>{'ID：'}</span>
                    <span>{data?.id}</span>
                    <Icon name="icon-games-copy" className="w-[15px] h-[15px] ml-[8px] text-[#36BA73]" />
                </div>

                <div className="w-full mt-[22px]">
                    {
                        menus?.map((v, index) => {
                            return <div key={index} className={classNames(styels.itemWrap, {
                                [styels.line]: v.type === 'line',
                                [styels.activity]: v.activity
                            })}
                            onClick={()=>{v.onClick?.()}}
                            >
                                {v.type === 'line' ? <></> : <div
                                    className={styels.item}
                                >
                                    <div className={
                                        classNames("w-[22px] h-full",tw.row_center)
                                    } >
                                    <Icon name={v.icon as IconName} className={v.iconClass}/>
                                    </div>
                                  
                                    <span>{v.text}</span>
                                </div>
                                }
                            </div>
                        })
                    }
                </div>

            </div>


        </div>

    </div>
}

export default SideMenu